module.exports = __webpack_public_path__ + "static/media/M1-31-Nixxa-Naybul-cod150.3fd25946.png";